<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">
        <template v-if="auxiliary">{{auxiliary.name}} -</template><template v-if="subjectId">{{subject.subjectFullName}}</template> 余额</span>
      <span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <account-date-choose v-model="accountDate"/>
      </Cell>
      <Cell class="label">辅助类别：</Cell>
      <Cell>
        <Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
      </Cell>
      <Cell>
        <Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
      </Cell>
      <Cell :flex="1">
      </Cell>
    </Row>
    <Row class="h-panel-body" type="flex" :space-x="10">
      <Cell :flex="1">
        <table class="balance" v-if="auxiliary">
            <thead class="header">
            <tr>
              <td rowspan="2">{{auxiliary.name}}编码</td>
              <td rowspan="2">{{auxiliary.name}}名称</td>
              <td colspan="2">期初余额</td>
              <td colspan="2">本期发生额</td>
              <td colspan="2">期末余额</td>
            </tr>
            <tr>
              <td>借方</td>
              <td>贷方</td>
              <td>借方</td>
              <td>贷方</td>
              <td>借方</td>
              <td>贷方</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in dataList" :key="item.subjecId">
              <!-- 显示辅助核算项目编码 -->
              <td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
              <!-- 显示辅助核算项目名称 -->
              <td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
              <!-- 显示期初借方余额 -->
              <td>{{item.beginningDebitBalance|numFormat}}</td>
              <!-- 显示期初贷方余额 -->
              <td>{{item.beginningCreditBalance|numFormat}}</td>
              <!-- 显示本期借方发生额 -->
              <td>{{item.currentDebitAmount|numFormat}}</td>
              <!-- 显示本期贷方发生额 -->
              <td>{{item.currentCreditAmount|numFormat}}</td>
              <!-- 显示期末借方余额 -->
              <td :class="{tip:item.endingDebitBalance<0}">{{item.endingDebitBalance|numFormat}}</td>
              <!-- 显示期末贷方余额 -->
              <td :class="{tip:item.endingCreditBalance<0}">{{item.endingCreditBalance|numFormat}}</td>
            </tr>
            <tr v-if="!dataList.length">
              <td colspan="8" class="text-center padding">暂无数据</td>
            </tr>
            </tbody>
          </table>
      </Cell>
      <Cell v-width="200">
        <Tree v-model="subjectId" @select="subjectSelect" :option="param" ref="subject" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
      </Cell>
    </Row>

  </app-content>
</template>
<script>
/**
 * 核算科目余额
 */
export default {
  name: "AuxiliaryAccountingBalance",
  data() {
    return {
      dataList: [],
      showNumPrice: false,
      loading: false,
      accountDate: null,
      auxiliary: null,
      auxiliaryItem: {},
      auxiliaryType: [],
      auxiliaryList: [],
      /**
       * 科目树形组件配置参数
       *
       * @description 用于配置左侧科目选择器的树形结构展示和数据模式
       * @property {string} keyName - 节点的唯一标识字段名，用于指定树节点的 ID 字段
       * @property {string} parentName - 父节点标识字段名，用于构建树形层级关系
       * @property {string} titleName - 节点标题显示字段名，用于指定树节点显示的文本内容
       * @property {string} dataMode - 数据模式，设置为 'list' 表示以列表形式处理数据
       * @property {Array} datas - 树形数据源数组，存储科目树的节点数据
       */
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'subjectFullName',
        dataMode: 'list',
        datas: []
      },
      subjectId: null,
      subject: null
    }
  },
  methods: {
    /**
     * 加载辅助核算类型数据
     *
     * @description 从API获取会计科目分类列表数据，设置辅助核算类型选项，并默认选中第一个选项
     * @returns {void}
     */
    loadAuxiliaryType() {
      // 获取会计科目分类列表数据
      this.$api.setting.accountingCategory.list().then(({data}) => {
        this.auxiliaryType = data;
        // 如果存在数据，则默认选中第一个选项
        if (data.length) {
          this.auxiliary = data[0];
        }
      });
    },
    /**
     * 加载辅助余额列表数据
     *
     * 该函数根据辅助核算项ID和会计日期查询对应的辅助余额数据，
     * 查询过程中会显示加载状态，查询完成后更新数据列表并关闭加载状态
     */
    loadList() {
      // 检查辅助核算项是否存在，避免无效请求
      if (this.auxiliary) {
        // 设置加载状态为true，显示加载动画
        this.loading = true;
        // 调用API接口加载辅助余额数据
        this.$api.accountbook.loadAuxiliarySummary({
          accountDate: this.accountDate,
          auxiliaryId: this.auxiliary.id,
          subjectId: this.subjectId
        }).then(({data}) => {
          // 将返回的数据赋值给数据列表
          // 使用 $set 或强制更新来确保数据响应性
          this.$set(this, 'dataList', data || []);
        }).finally(() => {
          // 无论请求成功或失败，最终都要关闭加载状态
          this.loading = false;
        });
      }

    },
    /**
     * 加载科目树数据
     *
     * @description 根据会计日期加载科目列表数据，构建科目树并默认选中第一个科目，同时触发余额数据加载
     * @returns {void}
     */
    loadSubject() {
      // 清空数据列表以准备加载新数据
      this.datalist = [];
      // 调用 API 接口获取指定会计日期的科目数据
      this.$api.accountbook.loadSubject1({accountDate: this.accountDate}).then(({data}) => {
        // 将获取到的科目数据设置为参数对象的 datas 属性，用于构建树形结构
        this.$set(this.param, "datas", data);
        // 如果存在科目数据，则进行初始化操作
        if (data.length) {
          // 设置默认选中的科目 ID 为第一个科目的 ID
          this.subjectId = data[0].id;
          // 保存第一个科目对象到 subject 属性
          this.subject = data[0];
          // 调用 loadList 方法加载该科目的辅助核算余额数据
          this.loadList();
          // 在下次DOM更新后更新选择器的选中状态
          this.$nextTick(() => {
            this.$refs.subject.updateSelect(this.subject.id);
          });
        }
      });
    },
    doSearch() {
      this.loadSubject();
    },
    /**
     * 选择科目时的处理函数
     * @param {Object} node - 被选中的科目节点对象
     * @returns {void}
     */
    subjectSelect(node) {
      this.subject = node;
      // 在加载新数据前先清空现有数据
      this.dataList = [];
      this.$nextTick(() => {
        this.loadList();
      });
    }
  },
  mounted() {
    this.loadAuxiliaryType();
  }
}
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center;  /* 垂直居中对齐 */
}
.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 35px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>